import React from 'react'
import $ from 'jquery'

function PageLoader() {
  return (
    <div className="spin-loader-container">
        <div className="sls-loader"></div>
    </div>
  )
}

export const isPageLoading = (status) => {
    if(status)
    {
        $(".spin-loader-container")
        .css("display", "flex")
        .hide()
        .fadeIn();
    }else
    {
        $(".spin-loader-container").fadeOut();
    }
}

export default PageLoader